import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { A, Box } from '@bridebook/ui';
import { networks } from '@bridebook/web/app-shared/lib/articles/constants';
import { getSocialShareUTM } from '@bridebook/web/lib/utils';
import openInBrowser from '@bridebook/web/lib/utils/open-in-browser';
import { Network } from './network.container';
import componentStyles from './social-sharing.style';
import { SocialSharingProps } from './social-sharing.types';

interface IProps extends SocialSharingProps {
  host: string;
  pathname: string;
  description: string;
}

const SocialSharingComponent: FC<IProps> = ({
  info,
  socialShareAnalytics,
  pinImage: img,
  itemLink,
  host,
  pathname,
  description,
}) => {
  const { t } = useTranslation('common');
  const { type, category } = info;

  const getShareUrl = (network: string) => {
    const itemUrl: string = itemLink || `${host}${pathname}`;
    const UTM: string = getSocialShareUTM(info, network);
    const shareUrl: string = encodeURIComponent(`${itemUrl}${UTM}`);
    const encodedDescription: string = encodeURIComponent(description);
    let url: string = '';
    switch (network) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
        break;
      case 'pinterest':
        url = `https://pinterest.com/pin/create/button/?url=${shareUrl}&media=${img}&description=${encodedDescription}`;
        break;
      case 'twitter':
        let msg = '';
        if (type === 'supplier') {
          msg = t('share.twitter.supplier');
        } else if (type === 'article') {
          msg = category.toLowerCase().includes('real wedding')
            ? t('shareTwitter.realWedding')
            : t('shareTwitter.wedding');
        }
        const encodedMsg = encodeURIComponent(msg);
        url = `https://twitter.com/share?text=${encodedMsg}&url=${shareUrl}&via=bridebook`;
        break;
      default:
        url = '';
    }
    return url;
  };

  const onClick = (network: string) => () => {
    const url = getShareUrl(network);
    if (socialShareAnalytics) socialShareAnalytics(network);
    openInBrowser(url, 'Share');
  };

  const styles = componentStyles();

  return (
    <Box style={styles.wrapper}>
      {networks.map((network) => (
        <A
          href={getShareUrl(network.name)}
          target="_blank"
          style={styles.networkWrap}
          key={`social-sharing-network-${network.name}`}
          onClick={onClick(network.name)}>
          <Network icon={network.icon} iconWidth={network.iconWidth} color={network.color} />
        </A>
      ))}
    </Box>
  );
};

export default SocialSharingComponent;
